import React, { useEffect, useState } from "react";
import "./Security.scss";
import toast from "react-hot-toast";
import { AgentApi } from "../../../../utils/api/Agent";
import BottomSaveButton from "../../buttons/BottomSaveButton";

const Security = () => {
  const [agencyEmployeeAccess, setAgencyEmployeeAccess] =
    useState<boolean>(true);
  const [initialAccess, setInitialAccess] = useState<boolean>(true);
  const [hasExistingSettings, setHasExistingSettings] = useState(false);

  const [state, setState] = useState({
    isLoading: false,
    saveIsLoading: false,
    showSaveButton: false,
  });

  const fetchSettings = async () => {
    setState((prev) => ({ ...prev, isLoading: true }));

    const res = await AgentApi.getAgentSettings();

    if (res.success && res.data?.success) {
      const settings = res.data.data;

      if (settings && typeof settings.agency_employee_access === "boolean") {
        setAgencyEmployeeAccess(settings.agency_employee_access);
        setInitialAccess(settings.agency_employee_access);
        setHasExistingSettings(true);
      } else {
        setAgencyEmployeeAccess(true);
        setInitialAccess(true);
        setHasExistingSettings(false);
      }
    }

    setState((prev) => ({ ...prev, isLoading: false }));
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
    if (agencyEmployeeAccess !== initialAccess) {
      setState((prev) => ({ ...prev, showSaveButton: true }));
    } else {
      setState((prev) => ({ ...prev, showSaveButton: false }));
    }
  }, [agencyEmployeeAccess, initialAccess]);

  const handleToggle = () => {
    setAgencyEmployeeAccess((prev) => !prev);
  };

  const onSubmitHandler = async () => {
    setState((prev) => ({ ...prev, saveIsLoading: true }));

    let res;

    if (hasExistingSettings) {
      res = await AgentApi.updateAgentSettings({
        agency_employee_access: agencyEmployeeAccess,
      });
    } else {
      res = await AgentApi.createAgentSettings({
        agency_employee_access: agencyEmployeeAccess,
      });
    }

    if (res.success && res.data?.success) {
      toast.success("Security settings updated");
      setInitialAccess(agencyEmployeeAccess);
      setHasExistingSettings(true);
      setState((prev) => ({
        ...prev,
        saveIsLoading: false,
        showSaveButton: false,
      }));
    } else {
      toast.error(res?.error || "Failed to update settings");
      setState((prev) => ({ ...prev, saveIsLoading: false }));
    }
  };

  const onClickDecline = () => {
    setAgencyEmployeeAccess(initialAccess);
  };

  return (
    <div className="security-settings">
      <h1 className="page-title">Security</h1>
      <p className="page-description">
        Manage account security and access permissions
      </p>

      <div className="security-card">
        <div className="card-content">
          <div className="text-content">
            <h2 className="card-title">Agency employee access</h2>
            <p className="card-subtitle">
              Allow agency employees to sign in to and manage your account
            </p>
          </div>

          <button
            type="button"
            className={`toggle-switch ${agencyEmployeeAccess ? "on" : "off"}`}
            onClick={handleToggle}
            disabled={state.isLoading || state.saveIsLoading}
            aria-label="Toggle agency employee access"
          >
            <span className="toggle-dot"></span>
          </button>
        </div>
      </div>

      <BottomSaveButton
        is_loading={state.saveIsLoading}
        cancle_button_name="Decline"
        save_button_name="Save Changes"
        button_hide={state.showSaveButton}
        onCancel={onClickDecline}
        submitButtonType={"button"}
        onSubmitClick={onSubmitHandler}
      />
    </div>
  );
};

export default Security;
